import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Ledgerentries } from "./../../master/ledger/shared/ledgerentries.model";

@Injectable({
  providedIn: 'root'
})

export class DaycloseserviceService {

  ledgerentries: Ledgerentries;

  constructor(private httpClient: HttpClient) {
    this.ledgerentries = new Ledgerentries;
  }

  getBaseUrl() {

    return environment.baseUrl;
  }

  IUDDayClose(ledgerentries: any) {

    ledgerentries.Id = 0;
    ledgerentries.TransactionId = 0;
    ledgerentries.LedgerId = 0;
    ledgerentries.EntryType = "D";
    ledgerentries.Amount = 0;
    ledgerentries.Remarks = null;
    ledgerentries.VoucherTypeId = 0;
    ledgerentries.TotalAmount = 0.0
    ledgerentries.LedgerName = "empty";
    ledgerentries.Amount = 0;
    ledgerentries.Remarks = null;
    ledgerentries.VoucherTypeId = 0;
    ledgerentries.Isopening = false;
    ledgerentries.CostCentreId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    ledgerentries.PersonId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];

    let body = ledgerentries;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Dayclose/IUD', body, { headers: headers });
  }

}
